import moment from 'moment';
import { httpClient } from './index';

//Appointment Requests
export const getPatientAppointmentRequests = async patientId => {
  const appointmentRequests = await httpClient.get(
    `/api/portal/appointment-requests?patientId=${patientId}&limit=${30}&offset=${0}`
  );

  return appointmentRequests.data.map(request => ({
    id: request.id,
    isAttachment: request.isAttachment,
    patient: {
      firstName: request.patient.firstName,
      lastName: request.patient.lastName,
      name: request.patient.name,
      email: request.patient.email,
      phone: request.patient.phone,
      birthdate: moment.utc(request.patient.birthdate).format('MM/DD/YYYY'),
      insuranceId: request.patient.insuranceId,
      insuranceName: request.patient.insuranceName,
    },
    sender: {
      name: request.sender.name,
      phone: request.sender.phone,
      practiceName: '',
    },
    receiver: request.receiver,
    portalNotes: request.portalNotes,
    visitReason: request.visitReason,
    createdAt: request.createdAt,
  }));
};
